import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  regions: PropTypes.array,
};

const defaultProps = {
  regions: [],
};

const GrantLocationTitle = (props) => {
  const { regions } = props;
  return (
    <div>
      {
        regions.map( (grants, index) => {
          return (
            <div key={index} className="grant-details">
              <a href={grants.url} target="_blank"><p className="grant-title">{grants.title}</p></a>
              <p className="grant-amount">{grants.amount}</p>
              <p className="grant-description">{grants.description}</p>
            </div>
          );
        })
      }
    </div>
  );
}

GrantLocationTitle.propTypes = propTypes;
GrantLocationTitle.defaultProps = defaultProps;

export default GrantLocationTitle;
